// extracted by mini-css-extract-plugin
module.exports = {"boton":"search_boton__1uFt9","container":"search_container__3CvOc","input":"search_input__3D2Mi"};